const LeaveStatCard = ({
  title,
  value,
  icon,
  items,
  field,
  iconBgColor,
}) => {
  return (
    <div className="relative group flex items-center gap-3 rounded-xl border border-gray-200 px-4 py-3 w-[210px] shadow-sm hover:shadow-md hover:border-gray-300 transition-all cursor-default">
      <div
        className={`flex items-center justify-center shrink-0 w-11 h-11 rounded-full ${iconBgColor}`}
      >
        <img src={icon} alt="" className="w-5 h-5 object-contain" />
      </div>

      <div>
        <p className="m-0 text-[11px] font-medium uppercase tracking-wide text-gray-400">
          {title}
        </p>

        <p className="m-0 mt-0.5 text-xl font-bold text-gray-900">
          {value}
          <span className="ml-1 text-[11px] font-medium text-gray-400">
            / yearly
          </span>
        </p>
      </div>

      <ul className="hidden group-hover:flex flex-col absolute top-full py-2 gap-1 right-0 mt-2 w-56 rounded-xl border border-gray-100 bg-primary-hrms shadow-lg divide-y divide-gray-100 z-20 overflow-hidden">
        {items.map((leave, index) => (
          <li
            key={index}
            className="flex items-center justify-between px-3.5 py-1 text-xs text-white"
          >
            <span>{leave.LeaveType}</span>

            <span className="font-semibold text-[#ECFDF5]">
              {leave[field]}
            </span>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default LeaveStatCard;